<div class="blotter_table_target" #tableTarget>
  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="ag-bcdfx pinned-border"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [toolPanelSuppressSideButtons]="true"
    [frameworkComponents]="frameworkComponents"
    multiSortKey="ctrl"
    enableColResize
    enableSorting
    rowHeight="22"
    (mouseup)="onMouseUp($event)"
    (contextmenu)="handleClick($event)"
  >
  </ag-grid-angular>
  <!-- Loading callout - absolutely positioned -->
  <div *ngIf="loadingDeals" class="loading-callout-container">
    <bfx-callout calloutType="neutral" message="{{loadingLabel}}"> </bfx-callout>
  </div>
</div>

<bfx-risk-trade-context-menu
  [currentLadderBlotter]="blotterInstance"
  bfxElementOnBody
></bfx-risk-trade-context-menu>
<bfx-blotter-column-selector
  [currentLadderBlotter]="blotterInstance"
  bfxElementOnBody
></bfx-blotter-column-selector>
